// A drawn poker table behind the login and welcome windows (cheap CSS, no 3D).
export function FeltBackdrop() {
  return (
    <div className="felt-backdrop" aria-hidden="true">
      <div className="felt-frame">
        <div className="felt-wood">
          <div className="felt">
            {[0, 1, 2, 3, 4].map((i) => (
              <span key={i} className="felt-card community" style={{ left: `${24 + i * 11}%` }} />
            ))}
            <span className="felt-card back" style={{ left: "10%", top: "8%" }} />
            <span className="felt-card back" style={{ left: "16%", top: "8%" }} />
            <span className="felt-card back" style={{ right: "16%", top: "8%" }} />
            <span className="felt-card back" style={{ right: "10%", top: "8%" }} />
          </div>
        </div>
        {["7% 4%", "50% 4%", "93% 4%", "4% 50%", "96% 50%", "25% 96%", "75% 96%"].map((pos) => {
          const [left, top] = pos.split(" ");
          return <span key={pos} className="seat-dot" style={{ left, top }} />;
        })}
      </div>
    </div>
  );
}
